<template>
  <div class="Aviso">
    <div class="libe_home_nav" v-if="scroll >= 88">
      <headNav :activeNav="'loan'"></headNav>
    </div>
    <div class="eshoy_content_wrap">
      <div class="libe_homenav" v-if="scroll < 88 ">
        <homeNav :activeNav="'loan'"></homeNav>
      </div>

    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";
import "../components/scss/Aviso.scss";


export default {
  name: "loan",
  components: { headNav, homeNav, footPage },
  data() {
    return {
      scroll: 0,
    }
  },
  mounted(){
    window.addEventListener('scroll',this.handleScroll)
  },
  methods: {
    handleScroll(){
      //或者使用document.querySelector('.class或者#id').scrollTop
      this.scroll = document.documentElement.scrollTop||document.body.scrollTop
    },
  },
  //销毁,否则跳到别的路由还是会出现
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style>
    .content_title {
      font-size: 25px;
    }
    .titleNum {
      color: #4e6cf8;
      font-weight: 600;
    }

    .bigContent_wrap{
      width: 1208px;
      height: auto;
      box-sizing: border-box;
      padding: 4px;
      background: #FFFFFF;
      box-shadow: 0px 20px 50px 0px rgba(40,44,73,0.04);
      border-radius: 12px;
      border: 1px solid #EDEDF4;
      position: relative;
    }
    .bigContent_downbg{
      width: 1198px;
      height: 422px;
      position: absolute;
      left: 4px;
      top: 4px;
      border-radius: 8px 8px 0px 0px;
      background: linear-gradient(180deg, rgba(218,234,255,0.7) 0%, #FFFFFF 100%);
    }
    .bigContent_new{
      width: 1198px;
      height: auto;
      position: relative;
      box-sizing: border-box;
      padding-top: 80px;
      padding-left: 80px;
      padding-right: 80px;
      border-radius: 8px 8px 0px 0px;
    }
    .title p span{
      border-bottom: 3px solid #4E67F1;
    }



</style>
